// Global handler for Compare Now button clicks
export const initializeCompareHandler = (handleCompareNowClick) => {
  window.handleCompareNowClick = handleCompareNowClick;
};

export const triggerCompareNow = (college) => {
  if (window.handleCompareNowClick) {
    window.handleCompareNowClick(college);
  } else {
    // Fallback: navigate to comparator with college ID
    window.location.href = `/comparator?compare=${college._id}`;
  }
};